var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutParaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 11,
    cy: 11,
    r: 11,
    fill: "url(#paint0_linear_50_31)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 10.3905V11.0039C17.6658 12.4415 17.2003 13.8403 16.3395 14.9917C15.4788 16.1432 14.2688 16.9855 12.8902 17.3931C11.5116 17.8007 10.0382 17.7518 8.68963 17.2536C7.3411 16.7554 6.18975 15.8346 5.40729 14.6286C4.62482 13.4225 4.25317 11.9959 4.34776 10.5614C4.44235 9.1269 4.99812 7.76141 5.93217 6.66857C6.86621 5.57574 8.1285 4.81411 9.53077 4.49729C10.933 4.18046 12.4002 4.32541 13.7133 4.91052M17.6666 5.66671L11 12.34L8.99998 10.34",
    stroke: "url(#paint1_linear_50_31)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_31",
    x1: 0,
    y1: 11,
    x2: 22,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_31",
    x1: 4.33331,
    y1: 11,
    x2: 17.6667,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutParaIcon);
export default __webpack_public_path__ + "static/media/about_para_icon.df55d5f6b19cde759a710e3942834d42.svg";
export { ForwardRef as ReactComponent };